import { render, staticRenderFns } from "./HeaderAgg.vue?vue&type=template&id=bed06bfe&"
import script from "./HeaderAgg.vue?vue&type=script&lang=js&"
export * from "./HeaderAgg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports